<template>
  <ImagePairsTrial
    :leadingImageUrl="leadingImageUrl"
    :trailingImageUrl="trailingImageUrl"
    :leadingButtonText="leadingButtonText"
    :trailingButtonText="trailingButtonText"
    :leadingButtonValue="leadingButtonValue"
    :trailingButtonValue="trailingButtonValue"
    :displaySeconds="displaySeconds"
    :step="step"
    @answered="handleResponse"
  />
</template>

<script>
import { ntDate } from '@neurotrack/web-core'
import startCase from 'lodash-es/startCase'
import essComponentProps from '@/mixins/essComponentProps'
import ImagePairsTrial from '@/components/exams/image-pairs/ImagePairsTrial/ImagePairsTrial.vue'

export default {
  data() {
    return {
      trial_start_time: null
    }
  },
  components: { ImagePairsTrial },
  mixins: [essComponentProps],
  watch: {
    step: {
      handler() {
        this.trial_start_time = ntDate.now()
      },
      immediate: true
    }
  },
  methods: {
    handleResponse(value) {
      if (this.trial.accepted_input_types?.includes('VIDEO')) {
        return this.handleTrialResponse()
      }
      const { trial_start_time } = this
      const data = value
        ? [
          {
            type: 'selection',
            value
          }
        ]
        : []
      this.handleTrialResponse({
        exam_trial_id: this.trial.exam_trial_id,
        trial_start_time,
        trial_end_time: ntDate.now(),
        metadata: {
          trial_scoring_type: this.trial.trial_scoring_type
        },
        data,
        timeout: data.length === 0
      })
    }
  },
  computed: {
    trialData() {
      return this.trial.component_data
    },
    leadingImageUrl() {
      const img = this.trialData.body.leading_image?.filename || ''
      if (img) {
        return this.getImageUrl(img)
      }
      return img
    },
    trailingImageUrl() {
      const img = this.trialData.body.trailing_image?.filename || ''
      if (img) {
        return this.getImageUrl(img)
      }
      return img
    },
    leadingButton() {
      return this.trialData?.footer?.leading_button
    },
    trailingButton() {
      return this.trialData?.footer?.trailing_button
    },
    leadingButtonText() {
      const txt = this.leadingButton?.text
      if (txt) {
        return startCase(txt.toLowerCase())
      }
      return txt
    },
    trailingButtonText() {
      const txt = this.trailingButton?.text
      if (txt) {
        return startCase(txt.toLowerCase())
      }
      return txt
    },
    leadingButtonValue() {
      return this.leadingButton?.value
    },
    trailingButtonValue() {
      return this.trailingButton?.value
    },
    displaySeconds() {
      return this.trial.display_seconds
    }
  }
}
</script>
